export default "__VITE_ASSET__da277dd7__"